import { render, staticRenderFns } from "./EtapaServicos.vue?vue&type=template&id=51f7a838"
import script from "./EtapaServicos.vue?vue&type=script&lang=js"
export * from "./EtapaServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports